!function() {
  "use strict";

  customElements.get("slideshow-component") ||
    customElements.define("slideshow-component", class extends HTMLElement {

      constructor() {
        super();

        this.flkty = null;

        this.isMobileView = null;

        this.flktyResizeEvent = () => {
          if (this.flkty) {
            this.flkty.resize();
          }
        };

        this.getTallestSlideItemEvent = () => {
          this.getTallestSlideItem();
        };

        this.handleResponsiveChange = () => {
          const isMobile = window.theme.isMobile();

          if (this.isMobileView === isMobile) {
            return;
          }

          this.isMobileView = isMobile;

          if (this.flkty) {
            this.flkty.destroy();
            this.flkty = null;
          }

          this.initSlider();
          this.getTallestSlideItem();
        };
      }

      connectedCallback() {
        this.items = this.querySelectorAll("[data-slide]");

        this.isMobileView = window.theme.isMobile();

        this.getTallestSlideItem();

        this.initSlider();

        this.bindScrollButton();

        document.addEventListener(
          "theme:resize:width",
          this.handleResponsiveChange
        );
      }

      initSlider() {
        const allItems = this.items;

        /*
         * Desktop:
         * Exclude slides marked as mobile-only.
         *
         * Mobile:
         * Include all slides.
         */
        const cellSelector = window.theme.isMobile()
          ? "[data-slide]"
          : "[data-slide]:not([data-mobile-only])";

        const items = this.querySelectorAll(cellSelector);

        const e = items.length;
        const t = parseInt(this.dataset.duration);
        const i = "true" === this.dataset.pageDots && e > 1;
        const s = "true" === this.dataset.navArrows && e > 1;

        let l = "true" === this.dataset.autoplay;

        l && (l = t);

        /*
         * Do not initialize Flickity when there is only
         * one applicable slide for the current device.
         */
        if (e > 1) {
          this.flkty = new window.theme.Flickity(this, {
            fade: true,
            cellSelector: cellSelector,
            autoPlay: l,
            pauseAutoPlayOnHover: false,
            wrapAround: true,
            adaptiveHeight: true,
            setGallerySize: true,
            imagesLoaded: true,
            pageDots: i,
            prevNextButtons: s,
            dragThreshold: 25,

            on: {
              ready: () => {
                requestAnimationFrame(this.flktyResizeEvent);

                document.addEventListener(
                  "theme:vars",
                  this.flktyResizeEvent
                );

                this.handleFirstSlideAnimation(true);
              },

              change: e => {
                this.handleFirstSlideAnimation(false);

                if (!this.flkty || !this.flkty.cells) {
                  return;
                }

                this.flkty.cells.forEach((t, i) => {
                  t.element
                    .querySelectorAll("a, button")
                    .forEach(t => {
                      t.setAttribute(
                        "tabindex",
                        i === e ? "0" : "-1"
                      );
                    });

                  t.element
                    .querySelectorAll("text-highlight")
                    .forEach(t => {
                      t.setTriggerAttribute(Boolean(i === e));
                    });
                });
              }
            }
          });

          window.theme.flickitySmoothScrolling(this);
        }
      }

      getTallestSlideItem() {
        /*
         * Only consider slides that are active for
         * the current device.
         */
        const isMobile = window.theme.isMobile();

        const activeItems = [...this.items].filter(item => {
          if (isMobile) {
            return true;
          }

          return !item.hasAttribute("data-mobile-only");
        });

        if (activeItems.length <= 1) {
          this.style.removeProperty("--item-min-h");
          return;
        }

        this.style.removeProperty("--item-min-h");

        const e = activeItems.map(e =>
          Math.floor(e.offsetHeight)
        );

        const t = Math.max(...e);

        const i = activeItems.some(e =>
          e.classList.contains("original-height")
        );

        const s = activeItems.some(e =>
          e.classList.contains("original-height-mobile")
        );

        const l = this.classList.contains("has-mobile-height");

        if (
          window.theme.isDesktop() &&
          !i
        ) {
          if (
            activeItems.some(
              e => Math.floor(e.offsetHeight) !== t
            )
          ) {
            this.style.setProperty(
              "--item-min-h",
              `${t}px`
            );
          }
        }

        if (
          window.theme.isMobile() &&
          !s &&
          l
        ) {
          if (
            activeItems.some(
              e => Math.floor(e.offsetHeight) !== t
            )
          ) {
            this.style.setProperty(
              "--item-min-h",
              `${t}px`
            );
          }
        }

        if (
          window.theme.isMobile() &&
          !i &&
          !l
        ) {
          if (
            activeItems.some(
              e => Math.floor(e.offsetHeight) !== t
            )
          ) {
            this.style.setProperty(
              "--item-min-h",
              `${t}px`
            );
          }
        }
      }

      handleFirstSlideAnimation(e = !1) {
        if (!e) {
          this.classList.remove(
            "slider--no-cached-images"
          );

          this.classList.remove(
            "slider--img-loaded"
          );

          return;
        }

        const t = this.querySelector(
          "[data-slide]:not([data-mobile-only])"
        );

        if (!t) {
          return;
        }

        const i = t.querySelectorAll(".lazy-image");

        const s = this.classList.contains("img-in");

        if (i.length && !s) {
          this.classList.add(
            "slider--no-cached-images"
          );

          const e = i => {
            requestAnimationFrame(() => {
              this.classList.add(
                "slider--img-loaded"
              );
            });

            i[0].removeEventListener(
              "transitionend",
              e
            );
          };

          i[0].addEventListener(
            "transitionend",
            e
          );
        }
      }

      bindScrollButton() {
        const e = this.querySelector(
          "[data-scroll-down]"
        );

        e &&
          e.addEventListener("click", e => {
            e.preventDefault();

            const t =
              document
                .querySelector("[data-site-header]")
                .classList.contains(
                  "site-header--fixed"
                )
                ? 60
                : 0;

            const i = parseInt(
              Math.ceil(
                this.offsetTop +
                this.offsetHeight -
                t
              )
            );

            window.scrollTo({
              top: i,
              left: 0,
              behavior: "smooth"
            });
          });
      }

      disconnectedCallback() {
        document.removeEventListener(
          "theme:resize:width",
          this.handleResponsiveChange
        );

        document.removeEventListener(
          "theme:vars",
          this.flktyResizeEvent
        );

        if (this.flkty) {
          this.flkty.destroy();
          this.flkty = null;
        }
      }
    });
}();